import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () =>
    import(/* webpackChunkName: "PokerLobbyTemplateWidget" */ './PokerLobbyTemplateWidget'),
  modules: ['./PokerLobbyTemplateWidget'],
  loading: () => <div />
});

export default LoadableWidget;
